<template>
  <div class="container">
    <downIcon />
    <Header />
    <img src="https://p5.ssl.qhimg.com/t110b9a930162acb98edc8b5db6.png" alt="" class="containerBg" />
    <div class="agenda">
      <div class="agendaTitle">会议日程</div>
      <div class="agendaTop">
        <div @click="goBack" class="agendaTopBack"><LeftOutlined />返回</div>
        <div class="agendaTopNav">
          <div class="agendaTopNavTitle">
            <span class="agendaBoldTitle">{{ obj?.title }}</span>
            <span class="agendaTopNavTitleTab">{{ obj?.activity_type }}</span>
          </div>
          <div class="agendaTopNavDet">
            <div class="agendaTopNavDetTop">
              <ClockCircleOutlined />
              <span class="agendaTopNavDetTime">{{ obj?.meet_date }}</span>
              <span class="agendaTopNavDet">{{ extractTime(obj?.start_date) }}-{{ extractTime(obj?.end_date) }}</span>
            </div>
            <div>
              <EnvironmentOutlined />
              <span class="agendaTopNavDetPlace">{{ obj?.address }}</span>
            </div>
          </div>
          <div class="agendaTopNavDesc">
            {{ obj?.description }}
          </div>
          <!-- <div v-if="obj?.video_url" @click="handleJump(obj?.video_url)" class="agendaTopNavReplay">
            <div class="agendaTopNavReplayItem">
              <img
                src="https://p2.ssl.qhimg.com/t110b9a9301df6b15bd07cb327c.png"
                alt=""
                class="agendaTopNavReplayIcon"
              />
              <div class="agendaTopNavReplayText">{{obj?.video_live_status==1?'观看直播':'观看回放'}}</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="agendaBottom">
        <div class="agendaBottomTitle">论坛议程
          <span class="agendaBottomTitleDesc">*具体议程时间以实际为准</span>
        </div>
        <div v-for="(item, index) in obj?.agendas" :key="index" class="agendaBottomBox">
          <div class="agendaBottomBoxLine"></div>
          <div class="agendaBottomBoxHead">
            <div class="agendaBottomBoxHeadLeft">
              <span class="agendaBottomBoxHeadLeftCircle"></span>
              <span class="agendaBottomBoxHeadLeftTitle" v-html="item.title"></span>
            </div>
            <div @click="handleJump(JSON.parse(item.extends).pdf_url)" v-if="item.extends" class="agendaBottomBoxHeadRight">
              <img
                src="https://p2.ssl.qhimg.com/t110b9a930131b2ffad91cf0cfb.png"
                alt=""
                class="agendaBottomBoxHeadRightIcon"
              />
              <span class="agendaBottomBoxHeadRightText">思维导图</span>
            </div>
          </div>
          <div class="agendaBottomBoxTime">{{ extractHourAndMinute(item.start_time) }}-{{ extractHourAndMinute(item.end_time) }}</div>
          <template v-if="item.speakers?.length > 0">
            <div class="agendaBottomBoxExpert" v-for="(itema, indexa) in item.speakers" :key="indexa">
              <div class="agendaBottomBoxExpertImg">
                <img v-if="itema.image_url" :src="itema.image_url" alt="" class="agendaBottomBoxExpertIcon" />
                <img class="agendaBottomBoxExpertIcon" v-else src="https://p0.ssl.qhimg.com/t110b9a9301e7bf54d9a3355999.png" alt="">
              </div>
              <div class="agendaBottomBoxExpertDesc">
                <div class="agendaBottomBoxExpertName">{{ itema.name }}</div>
                <div class="agendaBottomBoxExpertTitle">{{ itema.bio }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { LeftOutlined, ClockCircleOutlined, EnvironmentOutlined } from '@ant-design/icons-vue'
import Header from '../header-mobile.vue'
import downIcon from '../downIcon.vue'
import { agendaDetail } from '@/mock/2026/iscAgenda.js';
import { URLparams } from '@/utils/help.js'

const obj = ref({})
const id = URLparams.get('id')

onBeforeMount(async () => {
  fetch()
})

const goBack = () => {
  const baseUrl=window.location.origin
  window.open(`${baseUrl}/new/2026/agenda.html`, '_self')
}

const handleJump = (url) => {
  window.open(url)
}
const handleData = (str) => {
  return str.split(' ')[0].split('-').join('/')
}

function extractHourAndMinute(timeString) {
  const match = timeString.match(/^(\d{2}:\d{2})/);
  return match ? match[1] : '';
}

function extractTime(dateString) {
  if (!dateString) return ''
  return dateString.split(' ')[1].substring(0, 5)
}

// const fetch = () => {
  // getScheduleDetail(id)
  //   .then((res) => {
  //     const data = res.data.data
  //     data.agendas.forEach((item)=>{
  //       if(item.speakers.length > 0){
  //         item.agendaList = [
  //           ...item.speakers.filter(item => item.is_compere==1),
  //           ...item.speakers.filter(item => item.is_compere==0)
  //         ];
  //       }
  //     })
  //     obj.value = {
  //       ...data,
  //       meet_date: handleData(data.meet_date),
  //     }
  //   })
  //   .catch(() => {})
// }
const fetch = () => {
    const data = getAgendaItemById(id)
    obj.value = {
      ...data,
      meet_date: handleData(data.meet_date)
    }
}
const getAgendaItemById = (id) => {
  for (const date in agendaDetail) {
    const item = agendaDetail[date].find(
      item => item.id === id
    )

    if (item) {
      return item
    }
  }
  return null
}
</script>

<style lang="scss" scoped>
.container {
  background: #f3f3f3;
  padding-bottom: 24px;
  min-height: 100vh;
  &Bg {
    width: 100%;
    position: absolute;
    top: 45px;
  }
  .agenda {
    padding: 200px 16px 70px;
    &Title {
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      color: #242933;
    }
    &Top {
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(120px);
      padding: 16px;
      margin: 16px 0;
      &Back {
        font-size: 12px;
        line-height: 20px;
        color: #2085e9;
        margin-bottom: 12px;
        .anticon-left {
          margin-right: 4px;
        }
      }
      &Nav {
        &Title {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          color: #3d3d3d;
          margin-right: 6px;
          &Tab {
            width: 44px;
            height: 18px;
            border-radius: 4px;
            background: rgba(32, 133, 233, 0.1);
            font-size: 8px;
            line-height: 18px;
            text-align: center;
            color: #2085e9;
            margin-left: 6px;
            margin-top: 2px;
          }
        }
        &Det {
          font-size: 12px;
          line-height: 20px;
          color: #525966;
          margin: 8px 0 0;
          font-size: 12px;
          line-height: 20px;
          color: #525966;
          &Top {
            margin-bottom: 8px;
          }
          &Time {
            margin: 0 4px 0 8px;
          }
          &Place {
            margin-left: 8px;
          }
        }
        &Desc {
          font-size: 12px;
          line-height: 20px;
          color: #525966;
          margin: 16px 0 0;
          text-align: justify;
        }
        &Replay {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          height: 36px;
          border: 1px solid #e8eaed;
          padding: 8px 0;
          margin-top: 12px;
          &Item {
            display: flex;
            align-items: center;
            font-size: 12px;
            line-height: 20px;
            color: #2085e9;
          }
          &Icon {
            width: 12px;
            height: 12px;
            margin-right: 4px;
          }
        }
      }
    }
    &Bottom {
      border-radius: 16px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(120px);
      padding: 16px;
      &Title {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        color: #242933;
        margin-bottom: 22px;
        &Desc {
          font-size: 12px;
          line-height: 20px;
          color: #9398a1;
        }
      }
      &Box {
        margin-bottom: 16px;
        &Line {
          width: 1px;
          height: 91px;
          background: #e8eaed;
          position: absolute;
          top: 24px;
          left: 4px;
        }
        &Head {
          display: flex;
          justify-content: space-between;
          &Left {
            // width: 65%;
            display: flex;
            align-items: center;
            &Circle {
              border: 1px solid #525966;
              border-radius: 50%;
              width: 9px;
              height: 9px;
              display: inline-block;
              margin-right: 8px;
            }
            &Title {
              font-size: 12px;
              font-weight: 500;
              line-height: 20px;
              color: #3d3d3d;
              // background-color: pink;
            }
          }
          &Right {
            display: flex;
            align-items: center;
            &Icon {
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }
            &Text {
              font-size: 12px;
              line-height: 20px;
              color: #525966;
            }
          }
        }
        &Time {
          font-size: 12px;
          line-height: 20px;
          color: #8a9099;
          margin: 4px 0 10px 17px;
        }
        &Expert {
          display: flex;
          align-items: center;
          margin-left: 17px;
          margin-bottom: 12px;
          &Img{
            width: 36px !important;
            height: 36px;
            margin-right: 8px;
            border-radius: 50%;
            overflow: hidden;
            // border: 1px solid #e8eaed;
          }
          &Desc{
            flex: 1;
          }
          &Icon {
            width: 100%;
          }
          &Name {
            font-size: 12px;
            font-weight: 500;
            line-height: 20px;
            color: #3d3d3d;
          }
          &Title {
            font-size: 12px;
            line-height: 20px;
            color: rgba(61, 61, 61, 0.698);
          }
        }
      }
      &Box:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.agendaBottomBox:last-child .agendaBottomBoxLine {
  display: none;
}

.agendaBoldTitle{
  font-weight: 500;
}
</style>
